import { ref } from '@vue/composition-api'
import store from '@/store'

export const useShopFiltersSortingAndPagination = () => {
  const filters = ref({
    q: '',
    priceRangeDefined: 'all',
    priceRange: [0, 100],
    categories: [],
    brands: [],
    ratings: null,
    page: 1,
    perPage: 12,
  })

  const filterOptions = {
    priceRangeDefined: [
      { text: 'All', value: 'all' },
      { text: '<= $10', value: '<=10' },
      { text: '$10 - $100', value: '10-100' },
      { text: '$100 - $500', value: '100-500' },
      { text: '>= $500', value: '>=500' },
    ],
    categories: [
      'Genesis',
      'Alianza Indigena',
    ],
    brands: ['Bancannabis'],
    ratings: [
      { rating: 4, count: 160 },
      { rating: 3, count: 176 },
      { rating: 2, count: 291 },
      { rating: 1, count: 190 },
    ],
  }

  // Sorting
  const sortBy = ref({ text: 'Genesis', value: 'genesis' })
  const sortByOptions = [
    { text: 'Genesis', value: 'genesis' },
    { text: 'Alianza Indigena', value: 'alianzaindigena' },
    { text: 'All', value: 'all' },
  ]

  const showInactives = ref(null)

  return {
    // Filter
    filters,
    filterOptions,
    showInactives,
    // Sort
    sortBy,
    sortByOptions,
  }
}

export const useShopUi = () => {
  const itemView = 'list-view'
  const itemViewOptions = [
    { icon: 'GridIcon', value: 'grid-view' },
    { icon: 'ListIcon', value: 'list-view' },
  ]

  // Pagination count <= required by pagination component
  const totalProjects = ref(null)
  const dataInCache = ref(null)
  const isLoading = ref(null)

  return {
    itemView,
    itemViewOptions,
    totalProjects,
    isLoading,
    dataInCache,
  }
}

export const useShopRemoteData = () => {
  const genetics = ref([])
  const nftUseds = ref([])
  const fetchGenetics = (...args) => store.dispatch('projects-ecommerce/fetchMyGenetics', ...args)

  return {
    genetics,
    fetchGenetics,
    nftUseds,
  }
}
